import {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import LoadingBar from 'react-top-loading-bar';
import { useIsOnline } from 'react-use-is-online'
import { useClientRegisterMutation } from '../../Features/auth/authApiSlice';


function UserRegisterView() {
    const navigate = useNavigate();
    const [progress, setProgress] = useState(0);
    const { isOnline } = useIsOnline();

    const handleChange = (e)=>{
        setInput({...input, [e.target.name]: e.target.value})
    }

    const [input, setInput] = useState({
        password: '',
        password_comfirm: '',
        email: '',
        phone: '',
        fname: '',
        lname: '',
        gender: '',
        business_name: ''
    })

    const [errors, setErrors] = useState({
        password: '',
        email: '',
        phone: '',
        fname: '',
        lname: '',
        gender: '',
        business_name: ''
    })

    const [register] = useClientRegisterMutation()

    const handleSubmit = async(e)=>{
        e.preventDefault();
        // if(!isOnline){
        //     return swal("No Internet connection",'Please check Internet connection and try again',"error");
        // }
        if(input.password !== input.password_comfirm){
            return swal("Password and comfirm password don't match");
        }
        try {
            setProgress(80)
            const resp = await register(input).unwrap()
            if(resp.success === true){
                navigate(-1);
            }
            setProgress(100)
        } catch (err) {
            setProgress(100)
            if(err.data.hasOwnProperty('errors') == true){
                setErrors({
                    ...errors, 
                    password: err.data.errors.password, 
                    fname: err.data.errors.fname,
                    lname: err.data.errors.lname,
                    email: err.data.errors.email,
                    phone: err.data.errors.phone,
                    gender: err.data.errors.gender,
                    business_name: err.data.errors.business_name,
                })
            }else if(err.data.hasOwnProperty('error')){
                setProgress(100)
                return swal("Registration Failed",err.data.error,"error");
            }
        }          
    }

    const back = ()=> {
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again',"error"); 
        }
        setProgress(100)
        navigate(-1)
    };

    return (
            <div className="md:w-2/5 mb-12">
                <LoadingBar
                color="#14b8a6"
                height="4px"
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
                />
                <div className=''>     
                            <div class="bg-white shadow-md rounded-md flex flex-col justify-center">
                                <div class="p-2">
                                    <form onSubmit={handleSubmit} autoComplete="off" >
                                        <div class="">
                                            <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="fname" class="block text-xs text-gray-500">First name</label>
                                                    <input 
                                                        class="mt-1 p-1 outline-none focus:border-green-500 block w-full text-gray-700 text-sm  border-b border-gray-300"
                                                        type="text"
                                                        name="fname" 
                                                        id="fname" 
                                                        value={input.fname}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.fname}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="lname" class="block text-xs text-gray-500">Last name</label>
                                                    <input 
                                                        class="mt-1 p-1 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="text"
                                                        name="lname" 
                                                        id="lname" 
                                                        value={input.lname}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.lname}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="email" class="block text-xs text-gray-500">Email</label>
                                                    <input 
                                                        class="mt-1 p-1 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="text"
                                                        name="email" 
                                                        id="email" 
                                                        value={input.email}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.email}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="phone" class="block text-xs text-gray-500">Phone number</label>
                                                    <input 
                                                        class="mt-1 p-1 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="text"
                                                        name="phone" 
                                                        id="phone" 
                                                        value={input.phone}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.phone}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="business_name" class="block text-xs text-gray-500">Busines name</label>
                                                    <input 
                                                        class="mt-1 p-1 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="text"
                                                        name="business_name" 
                                                        id="business_name" 
                                                        value={input.business_name}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.business_name}</p>
                                                </div>
                                            </div>
                                            <div className='flex flex-col'>
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="number" class="w-full block text-xs text-gray-500">Gender</label>       
                                                    <select value={input.gender} name='gender' onChange={handleChange} className='mt-1 p-2 outline-none focus:border-green-500 block w-full text-gray-700 text-sm  border-b border-gray-300'>
                                                        <option value={false} className='text-gray-800 text-sm'>Select</option>
                                                        <option value={1} className='text-gray-800 text-sm'>Male</option>
                                                        <option value={2} className='text-gray-800 text-sm'>Female</option>
                                                    </select>
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.gender}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="password" class="block text-xs text-gray-500">Password</label>
                                                    <input 
                                                        class="mt-1 p-1 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="password"
                                                        name="password" 
                                                        id="password" 
                                                        value={input.password}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.password}</p>
                                                </div>
                                            </div>
                                            <div class="flex flex-col">
                                                <div class="col-span-6 sm:col-span-3 p-1">
                                                    <label for="password" class="block text-xs text-gray-500">Confirm Password</label>
                                                    <input 
                                                        class="mt-1 p-1 outline-none focus:border-green-500 block w-full text-gray-700 text-sm border-b border-gray-300"
                                                        type="password"
                                                        name="password_comfirm" 
                                                        id="password_comfirm" 
                                                        value={input.password_comfirm}
                                                        onChange={handleChange}
                                                    />
                                                    <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.password_comfirm}</p>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="flex items-end space-x-2">
                                                <div onClick={back} class="flex cursor-pointer hover:bg-gray-50 justify-center items-center w-full text-gray-900 px-4 py-3 rounded-md focus:outline-none">
                                                    Cancel
                                                </div>
                                                <button type='submit' class="bg-green-500 flex justify-center items-center w-full text-white px-2 py-2 rounded-md focus:outline-none">Submit</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                </div>
            </div>
        )

}

export default UserRegisterView;
